import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { glossaryKeys } from '@/shared/lib/query/queryKeys';

import { updateGlossaryCategoryApi } from '@/features/glossary/api';
import type { UpdateGlossaryCategoryRequest } from '@/features/glossary/api';

export const useUpdateGlossaryCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: UpdateGlossaryCategoryRequest) => updateGlossaryCategoryApi(request),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: glossaryKeys.all });
      queryClient.invalidateQueries({ queryKey: glossaryKeys.glossaryTree });
      queryClient.invalidateQueries({ queryKey: glossaryKeys.categoryInfo(data.fullyQualifiedName) });

      notification.success({
        message: NOTIFICATION_MESSAGES.GLOSSARY_CATEGORY_UPDATE_SUCCESS,
        placement: 'bottomLeft',
        duration: 3,
      });
    },
  });
};
